import type { IShop } from '@app/common';

// LE RESTAURANT SÉLECTIONNÉ D'OFFICE (Maxence, 1er nov. 2026 : « si
// l'utilisateur qui se connecte n'a qu'un seul restaurant, il faut
// l'auto-sélectionner, sinon c'est trop chiant, même sur les autres pages »).
// Règle PURE : un seul restaurant visible et rien de sélectionné, c'est lui ;
// sinon l'utilisateur choisit, et une sélection existante n'est jamais écrasée.
export function restaurantDOffice(visibles: IShop[] | undefined, selectionne: IShop | undefined): IShop | undefined {
  if (selectionne !== undefined) return undefined;
  if (visibles === undefined || visibles.length !== 1) return undefined;

  return visibles[0];
}
